import { Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import { deleteKeyFromStorage, getUserInfo } from '../../helpers/helpers';
import { useGetUserByIdQuery } from '../../services/users';
import {
  logout_icon,
  dashboard_icon,
  dashboard_white_icon,
  users_icon,
  users_white_icon,
  paw_icon,
  paw_icon_white,
} from '../../assets/icons/icons';
import { splash } from '../../assets/images/images';
import {
  NotificationFilled,
  SettingFilled,
  BulbOutlined,
  CalendarOutlined,
  MedicineBoxOutlined,
  DollarOutlined,
} from '@ant-design/icons';

const SideBar = ({ selected }) => {
  const navigate = useNavigate();
  const userInfo = getUserInfo();
  const { data: userData } = useGetUserByIdQuery(
    { id: userInfo?.id },
    { skip: !userInfo?.id }
  );
  const onClick = e => {
    e.key === '1' && navigate('/dashboard');
    e.key === '2' && navigate('/service');
    e.key === '3' && navigate('/announcements');
    e.key === '4' && navigate('/owners');
    e.key === '8' && navigate('/dogs');
    e.key === '5' && navigate('/appointments');
    e.key === '10' && navigate('/income');
    e.key === '6' && navigate('/tips');
    e.key === '9' && navigate('/medication');
    if (e.key === '7') {
      deleteKeyFromStorage('token');
      navigate('/');
    }
  };
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }
  const items = [
    getItem(
      <p
        className={`${
          selected === '1' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Dashboard
      </p>,
      '1',
      <div
        className={`${
          selected === '1' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === '1' ? dashboard_white_icon : dashboard_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${
          selected === '4' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Owners
      </p>,
      '4',
      <div
        className={`${
          selected === '4' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === '4' ? users_white_icon : users_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${
          selected === '8' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Dogs
      </p>,
      '8',
      <div
        className={`${
          selected === '8' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === '8' ? paw_icon_white : paw_icon}
          width={15}
          height={15}
          alt="Dogs"
        />
      </div>
    ),
    getItem(
      <p
        className={`${
          selected === '9' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Medication
      </p>,
      '9',
      <div
        className={`${
          selected === '9' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <MedicineBoxOutlined
          className={`${selected === '9' ? 'text-white' : 'text-primary'}`}
        />
      </div>
    ),
    // getItem(
    //   <p
    //     className={`${
    //       selected === '2' ? 'text-themeBlack' : 'text-themeGray-dark'
    //     } font-semibold text-base`}
    //   >
    //     Services
    //   </p>,
    //   '2',
    //   <div
    //     className={`${
    //       selected === '2' ? 'bg-primary' : 'bg-themeGray-light'
    //     } h-8 w-8 rounded-full flex justify-center items-center`}
    //   >
    //     <SettingFilled
    //       className={`${selected === '2' ? 'text-white' : 'text-primary'}`}
    //     />
    //   </div>
    // ),
    getItem(
      <p
        className={`${
          selected === '5' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Appointments
      </p>,
      '5',
      <div
        className={`${
          selected === '5' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <CalendarOutlined
          className={`${selected === '5' ? 'text-white' : 'text-primary'}`}
        />
      </div>
    ),
    getItem(
      <p
        className={`${
          selected === '10' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Income
      </p>,
      '10',
      <div
        className={`${
          selected === '10' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <DollarOutlined
          className={`${selected === '10' ? 'text-white' : 'text-primary'}`}
        />
      </div>
    ),
    getItem(
      <p
        className={`${
          selected === '3' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Announcements
      </p>,
      '3',
      <div
        className={`${
          selected === '3' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <NotificationFilled
          className={`${selected === '3' ? 'text-white' : 'text-primary'}`}
        />
      </div>
    ),
    getItem(
      <p
        className={`${
          selected === '6' ? 'text-themeBlack' : 'text-themeGray-dark'
        } font-semibold text-base`}
      >
        Tips
      </p>,
      '6',
      <div
        className={`${
          selected === '6' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <BulbOutlined
          className={`${selected === '6' ? 'text-white' : 'text-primary'}`}
        />
      </div>
    ),
    getItem(
      <div>
        <p
          className={`${
            selected === '7' ? 'text-themeBlack' : 'text-themeGray-dark'
          } font-semibold text-base`}
        >
          Log Out
        </p>
        {userData?.data?.user?.email && (
          <p className="text-themeGray-dark text-xs opacity-70">
            {userData.data.user.email}
          </p>
        )}
      </div>,
      '7',
      <div
        className={`${
          selected === '7' ? 'bg-primary' : 'bg-themeGray-light'
        } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img src={logout_icon} width={15} height={15} alt="" />
      </div>
    ),
  ];
  return (
    <div>
      <div className="flex justify-center">
        <img
          src={splash}
          width={120}
          height={120}
          alt="Guilty Dogs"
          className="mt-2 rounded-2xl"
        />
      </div>
      <Menu
        onClick={onClick}
        style={{
          minHeight: '68vh',
        }}
        selectedKeys={[selected]}
        defaultOpenKeys={['sub1']}
        mode="inline"
        items={items}
      />
    </div>
  );
};

export default SideBar;
